import { MapPin, ArrowRight } from "lucide-react";
import { Reveal } from "@/lib/motion";
import { requestService } from "@/lib/nav";

export const ServiceArea = () => (
  <section id="einsatzgebiet" className="py-20 lg:py-28 bg-white scroll-mt-20" data-testid="service-area-section">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
      <Reveal>
        <p className="text-xs font-semibold uppercase tracking-[0.2em] text-gold-dark mb-4">Einsatzgebiet</p>
        <h2 className="font-heading font-extrabold tracking-tight text-3xl sm:text-4xl lg:text-5xl text-charcoal leading-[1.15]">
          Für Sie in Bremen und Umgebung im Einsatz
        </h2>
        <p className="mt-5 text-lg text-charcoal-muted leading-relaxed">
          Wir sind in Bremen und im näheren Umland für Sie im Einsatz. Senden Sie uns Ihre Anfrage –
          wir prüfen kurzfristig, ob Ihr Standort in unserem Einsatzgebiet liegt.
        </p>
        <button onClick={() => requestService("")} data-testid="service-area-cta" className="mt-8 inline-flex items-center gap-2 rounded-md bg-forest px-6 py-3 text-white font-semibold hover:bg-forest-dark hover:-translate-y-0.5 transition-[transform,background-color] duration-200">
          Verfügbarkeit für meinen Standort anfragen <ArrowRight className="w-4 h-4" />
        </button>
      </Reveal>

      <Reveal delay={0.1}>
        <div className="relative rounded-2xl border border-border bg-sand overflow-hidden aspect-[4/3] grain" aria-hidden="true">
          <svg viewBox="0 0 400 300" className="w-full h-full" role="img" aria-label="Stilisierte Darstellung des Einsatzgebiets Bremen und Umgebung">
            <defs>
              <pattern id="grid" width="24" height="24" patternUnits="userSpaceOnUse">
                <path d="M24 0H0V24" fill="none" stroke="#E5E3D8" strokeWidth="1" />
              </pattern>
            </defs>
            <rect width="400" height="300" fill="url(#grid)" />
            <circle cx="200" cy="150" r="105" fill="#1B4332" opacity="0.06" />
            <circle cx="200" cy="150" r="70" fill="#1B4332" opacity="0.08" />
            <circle cx="200" cy="150" r="38" fill="#1B4332" opacity="0.10" />
            <path d="M120 120 Q200 90 285 130 T330 200" fill="none" stroke="#CBA36D" strokeWidth="2.5" strokeDasharray="6 6" opacity="0.7" />
            <circle cx="200" cy="150" r="9" fill="#1B4332" />
            <circle cx="200" cy="150" r="16" fill="none" stroke="#1B4332" strokeWidth="2" opacity="0.5" />
          </svg>
          <div className="absolute inset-x-0 bottom-0 p-5 flex items-center gap-2.5">
            <span className="inline-flex items-center justify-center w-10 h-10 rounded-full bg-forest text-white shrink-0"><MapPin className="w-5 h-5" /></span>
            <div>
              <p className="font-heading font-bold text-charcoal leading-none">Bremen</p>
              <p className="text-sm text-charcoal-muted mt-1">Hauptsächliches Einsatzgebiet inkl. näheres Umland</p>
            </div>
          </div>
        </div>
      </Reveal>
    </div>
  </section>
);
